import { useRedirectFunctions } from '@propelauth/react';

import { Breadcrumb } from '@/new/components/breadcrumb';
import { PageContainer } from '@/new/components/page-container';
import { PageHeader } from '@/new/components/page-header';
import { PageTitle } from '@/new/components/page-title';
import { Button } from '@/new/components/shadcn/button';

export function UserSettings() {
  const { redirectToAccountPage } = useRedirectFunctions();

  return (
    <>
      <Breadcrumb items={[{ href: '/', label: 'Home', active: true }]} />

      <PageContainer>
        <PageHeader>
          <PageTitle text="User Settings" iconClass="lucide--user-cog" />
        </PageHeader>

        <div className="my-8 max-w-md">
          <p className="mb-4 text-sm text-gray-600">
            Manage your password, email, and other account security settings.
          </p>
          <Button variant="primary" onClick={() => redirectToAccountPage()}>
            Manage Account
          </Button>
        </div>
      </PageContainer>
    </>
  );
}
